/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum StateOfGoodsEnum {
  New = "New",
  Used = "Used",
}

export function instanceOfStateOfGoodsEnum(value: any): boolean {
  for (const key in StateOfGoodsEnum) {
    if (Object.prototype.hasOwnProperty.call(StateOfGoodsEnum, key)) {
      if (StateOfGoodsEnum[key as keyof typeof StateOfGoodsEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function StateOfGoodsEnumFromJSON(json: any): StateOfGoodsEnum {
  return StateOfGoodsEnumFromJSONTyped(json, false);
}

export function StateOfGoodsEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StateOfGoodsEnum {
  return json as StateOfGoodsEnum;
}

export function StateOfGoodsEnumToJSON(value?: StateOfGoodsEnum | null): any {
  return value as any;
}

export function StateOfGoodsEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): StateOfGoodsEnum {
  return value as StateOfGoodsEnum;
}
